import {
  FETCH_DASHBOARD_STATS_REQUEST,
  FETCH_DASHBOARD_STATS_SUCCESS,
  FETCH_DASHBOARD_STATS_FAILURE,
  FETCH_BENEFICIARY_STATS_REQUEST,
  FETCH_BENEFICIARY_STATS_SUCCESS,
  FETCH_BENEFICIARY_STATS_FAILURE,
  FETCH_SURVEY_STATS_REQUEST,
  FETCH_SURVEY_STATS_SUCCESS,
  FETCH_SURVEY_STATS_FAILURE,
} from "../../actions/admin-dashboard/AdminDashboardActions";

const initialState = {
  loading: false,
  dashboardStats: {
    totalSurveyOfficers: 0,
    totalBeneficiaries: 0,
    totalBeneficiarySurveys: 0,
  },
  beneficiaryStats: [],
  surveyStats: [],
  beneficiarySummary: {},
  beneficiaryDemographics: {},
  error: null,
};

const adminDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_STATS_REQUEST:
    case FETCH_BENEFICIARY_STATS_REQUEST:
    case FETCH_SURVEY_STATS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_DASHBOARD_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        dashboardStats: action.payload,
        error: null,
      };

    case FETCH_BENEFICIARY_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        beneficiaryStats: action.payload.details || [],
        beneficiarySummary: action.payload.summary || {},
        beneficiaryDemographics: action.payload.demographics || {},
        error: null,
      };

    case FETCH_SURVEY_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        surveyStats: action.payload,
        error: null,
      };

    case FETCH_DASHBOARD_STATS_FAILURE:
    case FETCH_BENEFICIARY_STATS_FAILURE:
    case FETCH_SURVEY_STATS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default adminDashboardReducer;
